import { Box, Typography } from "@mui/material";
import React from "react";
import avatar1 from "../assets/image/avatar1.jpeg";
import avatar2 from "../assets/image/avatar2.jpeg";
import avatar3 from "../assets/image/avatar3.jpeg";
import EyeIcon from "../assets/SVG/eyeIcon";
// import GridComponent from "./GridComponent"
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useState, useMemo, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Them
import { getAllTrip, getTripGroup } from "../api/trip";
// import { useMemo,useEffect } from "react";
// import { useEffect } from "react";

export default function TableHistory({ title, mujahid, id, gridRef }) {
  const styleTableRow = { width: "100%", marginRight: "10px" };
  console.log(id);

  const titr = ["شماره اردو", "نام اردو", "مناطق اردو", "مسئول/مسئولین اردو"];
  const data = [
    {
      numberCamp: 1,
      campName: "اردو تهران",
      campLoc: "سپیدار",
      bossCamp: "امیری",
      pic: [avatar1],
    },
    {
      numberCamp: 2,
      campName: "اردو اصفهان",
      campLoc: "اصفهان",
      bossCamp: "هدایتی",
      pic: [avatar1, avatar2, avatar3],
    },
    {
      numberCamp: 3,
      campName: "اردو فیروزکوه",
      campLoc: "لزور",
      bossCamp: "زارع",
      pic: [avatar1, avatar2],
    },
    {
      numberCamp: 3,
      campName: "اردو فیروزکوه",
      campLoc: "لزور",
      bossCamp: "زارع",
      pic: [avatar1, avatar2, avatar3],
    },
    {
      numberCamp: 3,
      campName: "اردو فیروزکوه",
      campLoc: "لزور",
      bossCamp: "زارع",
      pic: [avatar1, avatar2, avatar3],
    },
  ];
  const MissionResultRenderer = ({ value }) => (
    <span
      style={{
        display: "flex",
        justifyContent: "center",
        height: "100%",
        alignItems: "center",
      }}
    >
      {
        <>
          <img
            alt={`${value}`}
            src={avatar1}
            style={{ width: "40px", height: "40px", borderRadius: "50%" }}
          />
          <img
            alt={`${value}`}
            src={avatar2}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "-20px",
            }}
          />
          <img
            alt={`${value}`}
            src={avatar3}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "-20px",
            }}
          />
        </>
      }
    </span>
  );
  // const GridExample = () => {
  // Row Data: The data to be displayed.
  const [rowData, setRowData] = useState([]);

  // Column Definitions: Defines & controls grid columns.
  const [colDefs] = useState([
    {
      field: "project",
      headerName: "نام پروژه",
      width: 225,
    },
    {
      field: "name",
      headerName: "نام اردو",
      width: 150,
    },
    {
      field: "area",
      headerName: "مناطق اردو",
      width: 320,
      cellRenderer: (x) => {
        return (
          <>
            {x?.data?.areas?.map((z, i) => (
              <>
                <Typography>
                  {z.name}
                  {x?.data?.areas?.length - 1 !== i && " " + "-" + " "}
                </Typography>
              </>
            ))}
          </>
        );
        // console.log(x.data.areas);
      },
    },
    {
      field: "groupsWithAccess",
      headerName: "مسئول/مسئولین اردو",
      width: 320,
      cellRenderer: (x) => {
        return (
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              height: "100%",
              alignItems: "center",
              marginRight: "5px",
            }}
          >
            {
              <>
                {x.value.map((y, i) => (
                  <>
                    {y.group.user.pic && (
                      <img
                        alt={`${x}`}
                        src={y.group.user.pic}
                        style={
                          x.value.length === 0
                            ? {
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                              }
                            : {
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                marginRight: "-20px",
                              }
                        }
                      />
                    )}
                  </>
                ))}
                {x.value.map((z, i) => (
                  <Box mr="3px" display="flex">
                    <Typography>{" " + z.group.user.name + " "}</Typography>
                    {i + 1 !== x.value.length && (
                      <Typography px="3px">{" " + "-" + " "}</Typography>
                    )}
                  </Box>
                ))}
              </>
            }
          </span>
        );
      },
    },
    {
      field: "عملیات",
      width: 105,
      cellRenderer: (x) => {
        return (
          <Box
            display="flex"
            justifyContent={"center"}
            p="3px"
            borderRadius={"8px"}
            sx={{
              bgcolor: "#EEEEEE",
              transition: "0.3s all",
              cursor: "pointer",
              ":hover": { bgcolor: "#A2E5C5" },
            }}
          >
            <EyeIcon />
          </Box>
        );
      },
    },
  ]);
  // useEffect(() => {
  //   fetch("https://www.ag-grid.com/example-assets/space-mission-data.json")
  //     .then((result) => result.json())
  //     .then((rowData) => setRowData(rowData));
  // }, []);
  useEffect(() => {
    getTripGroup(id)
      .then((x) => setRowData(x))
      .catch((z) => console.log(z));
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
  }));
  return (
    <>
      <div className="ag-theme-quartz" style={{ height: 440 }}>
        <AgGridReact
          pagination={true}
          ref={gridRef}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          // pagination={true}
          rowSelection="multiple"
          onSelectionChanged={(event) => console.log("Row Selected!")}
          onCellValueChanged={(event) =>
            console.log(`New Cell Value: ${event.value}`)
          }
        />
      </div>
    </>
  );
}
